module.exports = __webpack_public_path__ + "img/gallery06.ab6f428b.png";